import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-white border-top pt-5 pb-4 mt-5">
            <div className="container">
                <div className="row g-4 mb-5">
                    {/* Brand and Mission */}
                    <div className="col-lg-4">
                        <Link className="navbar-brand text-dark fs-3 fw-bold mb-3 d-block" to="/home">
                            <i className="las la-shield-alt text-primary me-2"></i>
                            SECURE360
                        </Link>
                        <p className="text-muted small pe-lg-5">
                            Empowering organizations with enterprise-grade security tools and real-time monitoring.
                            Our mission is to make the internet a safer place for everyone, one scan at a time.
                        </p>
                        <div className="d-flex gap-3 mt-4">
                            <a href="#!" className="btn btn-outline-dark btn-sm rounded-circle p-0 d-flex align-items-center justify-content-center w-[32px] h-[32px]">
                                <i className="lab la-twitter"></i>
                            </a>
                            <a href="#!" className="btn btn-outline-dark btn-sm rounded-circle p-0 d-flex align-items-center justify-content-center w-[32px] h-[32px]">
                                <i className="lab la-linkedin-in"></i>
                            </a>
                            <a href="#!" className="btn btn-outline-dark btn-sm rounded-circle p-0 d-flex align-items-center justify-content-center w-[32px] h-[32px]">
                                <i className="lab la-github"></i>
                            </a>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div className="col-md-4 col-lg-2 ms-lg-auto">
                        <h6 className="fw-bold text-uppercase mb-3 small">Platform</h6>
                        <ul className="list-unstyled">
                            <li className="mb-2"><Link to="/plans" className="text-muted text-decoration-none small">Pricing & Plans</Link></li>
                            <li className="mb-2"><Link to="/app" className="text-muted text-decoration-none small">Mobile App <span className="badge bg-primary-subtle text-primary x-small ms-1">2026</span></Link></li>
                            <li className="mb-2"><Link to="/ssl-check" className="text-muted text-decoration-none small">SSL Checker</Link></li>
                            <li className="mb-2"><Link to="/demo-check" className="text-muted text-decoration-none small">Quick Demo</Link></li>
                            <li className="mb-2"><Link to="/register" className="text-muted text-decoration-none small">Get Started</Link></li>
                            <li className="mb-2"><Link to="/login" className="text-muted text-decoration-none small">Sign In</Link></li>
                        </ul>
                    </div>

                    {/* Company */}
                    <div className="col-md-4 col-lg-2">
                        <h6 className="fw-bold text-uppercase mb-3 small">Company</h6>
                        <ul className="list-unstyled">
                            <li className="mb-2"><Link to="/about" className="text-muted text-decoration-none small">About Us</Link></li>
                            <li className="mb-2"><Link to="/roadmap" className="text-muted text-decoration-none small">Our Roadmap</Link></li>
                            <li className="mb-2"><Link to="/documentation" className="text-muted text-decoration-none small">Documentation</Link></li>
                            <li className="mb-2"><Link to="/privacy" className="text-muted text-decoration-none small">Privacy Policy</Link></li>
                            <li className="mb-2"><Link to="/terms" className="text-muted text-decoration-none small">Terms of Service</Link></li>
                        </ul>
                    </div>

                    {/* Contact */}
                    <div className="col-md-4 col-lg-3">
                        <h6 className="fw-bold text-uppercase mb-3 small">Stay Updated</h6>
                        <p className="text-muted small mb-3">Subscribe to our newsletter for the latest security threat alerts.</p>
                        <form className="d-flex gap-2">
                            <input type="email" className="form-control form-control-sm border-0 bg-light" placeholder="Email address" />
                            <button type="submit" className="btn btn-primary btn-sm px-3">
                                <i className="las la-paper-plane"></i>
                            </button>
                        </form>
                    </div>
                </div>

                <hr className="my-4 text-muted opacity-10" />

                <div className="row align-items-center">
                    <div className="col-md-6 text-center text-md-start">
                        <p className="text-muted mb-0 x-small">
                            &copy; {currentYear} Secure360 Security. All rights reserved.
                            Designed with <i className="las la-heart text-danger"></i> for a safer web.
                        </p>
                    </div>
                    <div className="col-md-6 text-center text-md-end mt-2 mt-md-0">
                        <span className="badge bg-light text-muted fw-normal p-2">
                            <i className="las la-lock me-1"></i> SSL SECURED
                        </span>
                    </div>
                </div>
            </div>

            <style>{`
        .x-small { font-size: 0.75rem; }
      `}</style>
        </footer>
    );
};

export default Footer;
